'use strict';
/*!
    ZoomPan
    License: MIT
    Credit: https://github.com/End-S/zoomPan
*/

angular.module('app')

.directive('imageZoom', function ($window, $document)
{
    function link(scope, element) {

        // SETUP
        var frame, image, zoomlvl, fWidth, fHeight, rect, rootDoc, offsetL, offsetT, xPosition, yPosition, pan;

        // Template has loaded, grab elements.
        scope.$watch('$viewContentLoaded', function()
        {
           frame = angular.element($document[0].querySelector("#"+scope.frame))[0];
           image = angular.element($document[0].querySelector("#"+scope.img))[0];

           zoomlvl = (scope.zoomlvl === undefined) ? "2.5" : scope.zoomlvl;
        });

        // MOUSE TRACKER OVER IMG
        scope.trackMouse = function($event)
        {
            fWidth = frame.clientWidth;
            fHeight = frame.clientHeight;

            rect = frame.getBoundingClientRect();
            rootDoc = frame.ownerDocument.documentElement;

            //calculate the offset of the frame from the top and left of the document
            offsetT = rect.top + $window.pageYOffset - rootDoc.clientTop;
            offsetL = rect.left + $window.pageXOffset - rootDoc.clientLeft;

            //calculate current cursor position inside the frame, as a percentage
            xPosition = (($event.pageX - offsetL) / fWidth) * 100;
            yPosition = (($event.pageY - offsetT) / fHeight) * 100;

            pan = xPosition + "% " + yPosition + "% 0";
            image.style.transformOrigin = pan;
        };

        // MOUSE OVER | ZOOM-IN
        element.on('mouseover', function() {
            image.style.transform = 'scale('+zoomlvl+')';
        });

        // MOUSE OUT | ZOOM-OUT
        element.on('mouseout', function() {
            image.style.transform = 'scale(1)';
        });
    }

    return {
        restrict: 'EA',
        scope: {
            src: '@src',
            frame: '@frame',
            img: '@img',
            zoomlvl: '@zoomlvl'
        },
        templateUrl: 'directives/image-zoom/imageZoom.html',
        link: link
    };
});

